var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.isRegister && 'is-register', _vm.isMobile && 'is-mobile'],attrs:{"id":"app"}},[(_vm.isShowMenu)?_c('div',{staticClass:"account-header"},[_c('ConsoleHeader')],1):_vm._e(),_c('div',{class:['account-container', { 'account-padding': _vm.isShowMenu }]},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }